var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02273 6C6.68287 6 7.21802 5.46274 7.21802 4.8C7.21802 4.13726 6.68287 3.6 6.02273 3.6C5.36258 3.6 4.82743 4.13726 4.82743 4.8C4.82743 5.46274 5.36258 6 6.02273 6Z",
    fill: "#503EB6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02273 0C3.39308 0 1.24155 2.16 1.24155 4.8C1.24155 7.44 3.39308 9.6 6.02273 9.6C8.65237 9.6 10.8039 7.44 10.8039 4.8C10.8039 2.16 8.65237 0 6.02273 0ZM6.02273 0.6C6.32155 0.6 6.62037 0.9 6.62037 1.2C6.62037 1.5 6.32155 1.8 6.02273 1.8C5.66414 1.8 5.42508 1.56 5.42508 1.2C5.42508 0.84 5.66414 0.6 6.02273 0.6ZM6.02273 7.2C4.7079 7.2 3.63214 6.12 3.63214 4.8C3.63214 3.48 4.7079 2.4 6.02273 2.4C7.33755 2.4 8.41332 3.48 8.41332 4.8C8.41332 6.12 7.33755 7.2 6.02273 7.2Z",
    fill: "#503EB6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9234 12H1.12202C0.643902 12 0.345078 11.46 0.584137 11.1L1.77943 9.06C2.8552 10.14 4.34931 10.8 5.96296 10.8C7.57661 10.8 9.07073 10.14 10.1465 9.06L11.3418 11.1C11.7004 11.46 11.4016 12 10.9234 12Z",
    fill: "#503EB6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraStatus);
export default __webpack_public_path__ + "static/media/camera-status.a904d43af7eff7c1607e60e0c4c52f86.svg";
export { ForwardRef as ReactComponent };